import { render, staticRenderFns } from "./DebugLoginStudent.vue?vue&type=template&id=44f75c42&scoped=true&lang=pug"
import script from "./DebugLoginStudent.vue?vue&type=script&lang=ts"
export * from "./DebugLoginStudent.vue?vue&type=script&lang=ts"
import style0 from "./DebugLoginStudent.vue?vue&type=style&index=0&id=44f75c42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f75c42",
  null
  
)

export default component.exports